"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.compileStrategyToComponentConfig = exports.compileFilterToBoolean = void 0;
/* eslint-disable no-param-reassign */
const assert_never_1 = __importDefault(require("assert-never"));
const common_1 = require("@tencent/tccp-frontend-contract/common");
const spu_1 = require("@tencent/tccp-frontend-contract/spu");
const trade_1 = require("@tencent/tccp-frontend-contract/trade");
const component_1 = require("../types/component");
const component_2 = require("./component");
/** 解释Filters当中的操作子，用来定位一组状态值 */
function compileFilterToBoolean(param, operator, value) {
    switch (operator) {
        case common_1.FilterOperatorEnum.StringEqual:
            return String(param) === String(value);
        case common_1.FilterOperatorEnum.NumberEqual:
            return Number(param) === Number(value);
        case common_1.FilterOperatorEnum.DateEqual:
            // 等支持Date类型之后再验证
            return param === value;
        case common_1.FilterOperatorEnum.StringNotEqual:
            return String(param) !== String(value);
        case common_1.FilterOperatorEnum.NumberNotEqual:
            return Number(param) !== Number(value);
        case common_1.FilterOperatorEnum.DateNotEqual:
            return param !== value;
        case common_1.FilterOperatorEnum.NumberGreaterThan:
        case common_1.FilterOperatorEnum.DateGreaterThan:
            return param > value;
        case common_1.FilterOperatorEnum.NumberLessThan:
            return Number(param) < Number(value);
        case common_1.FilterOperatorEnum.DateLessThan:
            return param < value;
        case common_1.FilterOperatorEnum.NumberGreaterThanEqual:
            return Number(param) >= Number(value);
        case common_1.FilterOperatorEnum.DateGreaterThanEqual:
            return param >= value;
        case common_1.FilterOperatorEnum.NumberLessThanEqual:
            return Number(param) <= Number(value);
        case common_1.FilterOperatorEnum.DateLessThanEqual:
            return param <= value;
        case common_1.FilterOperatorEnum.StringIn:
            return value.some(v => String(v) === String(param));
        case common_1.FilterOperatorEnum.NumberIn:
            return value.some(v => Number(v) === Number(param));
        case common_1.FilterOperatorEnum.DateIn:
            return value.includes(param);
        case common_1.FilterOperatorEnum.StringNotIn:
            return !value.some(v => String(v) === String(param));
        case common_1.FilterOperatorEnum.NumberNotIn:
            return !value.some(v => Number(v) === Number(param));
        case common_1.FilterOperatorEnum.DateNotIn:
            return !value.includes(param);
        case common_1.FilterOperatorEnum.NumberBetween:
            return Number(param) >= Number(value[0]) && Number(param) <= Number(value[1]);
        case common_1.FilterOperatorEnum.DateBetween:
            return param >= value[0] && param <= value[1];
        case common_1.FilterOperatorEnum.NumberNotBetween:
            return Number(param) < Number(value[0]) || Number(param) > Number(value[1]);
        case common_1.FilterOperatorEnum.DateNotBetween:
            return param < value[0] || param > value[1];
        default:
            (0, assert_never_1.default)(operator);
    }
}
exports.compileFilterToBoolean = compileFilterToBoolean;
/**
 * 将策略转换为组件配置
 */
function compileStrategyToComponentConfig(componentDraft, rule) {
    var _a, _b, _c, _d, _e, _f, _g;
    if (rule) {
        const { isRequired, isStatic, isHidden, isCalculable, defaultValue, ref, constrictorRuleList, refCalOp, } = rule;
        if (componentDraft.isField) {
            componentDraft.isRequired = isRequired !== null && isRequired !== void 0 ? isRequired : false;
            componentDraft.isCalculable = isCalculable !== null && isCalculable !== void 0 ? isCalculable : false;
            if (isStatic !== undefined) {
                if (defaultValue !== undefined && defaultValue !== null) {
                    componentDraft.isStatic = true;
                    delete componentDraft.defaultValueCalculator;
                    componentDraft.defaultValue = defaultValue;
                }
                else if (ref !== undefined && ref !== null) {
                    componentDraft.isComputed = true;
                    delete componentDraft.defaultValue;
                    componentDraft.defaultValueCalculator = (current) => {
                        if (Array.isArray(ref)) {
                            // 空值算0
                            if (refCalOp === undefined) {
                                return undefined;
                            }
                            if (refCalOp === '*') {
                                return ref.map(key => { var _a; return (_a = current[key]) !== null && _a !== void 0 ? _a : 0; }).reduce((a, b) => Number(a) * Number(b), 1);
                            }
                            if (refCalOp === '+') {
                                return ref.map(key => { var _a; return (_a = current[key]) !== null && _a !== void 0 ? _a : 0; }).reduce((a, b) => Number(a) + Number(b), 0);
                            }
                            if (refCalOp === 'max') {
                                const arr = ref.map(key => current[key]).filter(v => v !== undefined);
                                if (!arr.length) {
                                    return undefined;
                                }
                                return Math.max(...arr.map(Number));
                            }
                            if (refCalOp === 'min') {
                                const arr = ref.map(key => current[key]).filter(v => v !== undefined);
                                if (!arr.length) {
                                    return undefined;
                                }
                                return Math.min(...arr.map(Number));
                            }
                            if (refCalOp === 'int-div-floor') {
                                const arr = ref.map(key => current[key]);
                                if (arr[0] !== undefined && arr[1] !== undefined && Number(arr[1]) !== 0) {
                                    return Math.floor(Number(arr[0]) / Number(arr[1]));
                                }
                                return undefined;
                            }
                            if (refCalOp === 'int-div-ceiling') {
                                const arr = ref.map(key => current[key]);
                                if (arr[0] !== undefined && arr[1] !== undefined && Number(arr[1]) !== 0) {
                                    return Math.ceil(Number(arr[0]) / Number(arr[1]));
                                }
                                return undefined;
                            }
                            (0, assert_never_1.default)(refCalOp);
                        }
                        return current[ref];
                    };
                }
            }
            else {
                componentDraft.isStatic = false;
                componentDraft.isComputed = false;
                delete componentDraft.defaultValueCalculator;
                // 需要用户输入的也可以有默认值
                if (defaultValue !== undefined && defaultValue !== null) {
                    componentDraft.defaultValue = defaultValue;
                }
            }
        }
        if (isHidden) {
            (0, component_2.revertToEmptyComponent)(componentDraft);
            return;
        }
        switch (componentDraft.type) {
            case component_1.ComponentType.Enum: {
                let includes;
                const excludes = [];
                for (const rule of constrictorRuleList) {
                    switch (rule.operator) {
                        case trade_1.ValueConstrictorEnum.Subset: {
                            includes = includes
                                ? includes.filter(v => rule.value.map(String).includes(String(v)))
                                : rule.value.map(String);
                            break;
                        }
                        case trade_1.ValueConstrictorEnum.Exclude: {
                            excludes.push(...rule.value);
                            break;
                        }
                    }
                }
                for (const option of componentDraft.options) {
                    if (includes === null || includes === void 0 ? void 0 : includes.length) {
                        option.disabled = !includes.includes(option.value);
                    }
                    if (excludes.length) {
                        option.disabled || (option.disabled = excludes.includes(option.value));
                    }
                }
                // 回归验证当前defaultValue，如果已经不满足条件，则重新设置
                const currentDefaultValue = componentDraft.defaultValue;
                const shouldSetDefaultValue = !componentDraft.defaultValueCalculator &&
                    (currentDefaultValue === undefined ||
                        currentDefaultValue === null ||
                        componentDraft.options.some(option => (Array.isArray(currentDefaultValue)
                            ? currentDefaultValue.map(String).includes(String(option.value))
                            : String(currentDefaultValue) === option.value) && option.disabled));
                if (shouldSetDefaultValue) {
                    if (Array.isArray(currentDefaultValue)) {
                        const lastDefaultValue = componentDraft.options
                            .filter(({ disabled, value }) => !disabled && currentDefaultValue.map(String).includes(String(value)))
                            .map(({ value }) => value);
                        if (lastDefaultValue === undefined ||
                            lastDefaultValue === null ||
                            lastDefaultValue.length === 0) {
                            delete componentDraft.defaultValue;
                        }
                        else if ([spu_1.ValueTypeEnum.DecimalArray, spu_1.ValueTypeEnum.IntArray].includes(componentDraft.valueType)) {
                            componentDraft.defaultValue = lastDefaultValue.map(Number);
                        }
                        else {
                            componentDraft.defaultValue = lastDefaultValue;
                        }
                    }
                    else {
                        const lastDefaultValue = (_a = componentDraft.options.find(({ disabled }) => !disabled)) === null || _a === void 0 ? void 0 : _a.value;
                        if (lastDefaultValue === undefined || lastDefaultValue === null) {
                            delete componentDraft.defaultValue;
                        }
                        else if ([spu_1.ValueTypeEnum.Decimal, spu_1.ValueTypeEnum.Int].includes(componentDraft.valueType)) {
                            componentDraft.defaultValue = Number(lastDefaultValue);
                        }
                        else {
                            componentDraft.defaultValue = lastDefaultValue;
                        }
                    }
                }
                break;
            }
            case component_1.ComponentType.Input: {
                for (const rule of constrictorRuleList) {
                    switch (rule.operator) {
                        case trade_1.ValueConstrictorEnum.Range: {
                            const [min, max] = rule.value;
                            const nextMin = Math.max((_c = (_b = componentDraft.range) === null || _b === void 0 ? void 0 : _b[0]) !== null && _c !== void 0 ? _c : Number.NEGATIVE_INFINITY, min);
                            const nextMax = Math.min((_e = (_d = componentDraft.range) === null || _d === void 0 ? void 0 : _d[1]) !== null && _e !== void 0 ? _e : Number.POSITIVE_INFINITY, max);
                            componentDraft.range = [nextMin, nextMax];
                            break;
                        }
                    }
                }
                // 回归验证当前defaultValue，如果已经不满足条件，则重新设置
                const currentDefaultValue = componentDraft.defaultValue;
                const shouldSetDefaultValue = !componentDraft.defaultValueCalculator &&
                    componentDraft.range &&
                    (currentDefaultValue === undefined ||
                        currentDefaultValue === null ||
                        currentDefaultValue < componentDraft.range[0] ||
                        currentDefaultValue > componentDraft.range[1]);
                if (shouldSetDefaultValue) {
                    if (currentDefaultValue === undefined ||
                        currentDefaultValue === null ||
                        currentDefaultValue < componentDraft.range[0]) {
                        componentDraft.defaultValue = (_f = componentDraft.range) === null || _f === void 0 ? void 0 : _f[0];
                    }
                    else {
                        componentDraft.defaultValue = (_g = componentDraft.range) === null || _g === void 0 ? void 0 : _g[1];
                    }
                }
                break;
            }
        }
    }
}
exports.compileStrategyToComponentConfig = compileStrategyToComponentConfig;
